import { Col, Row } from "react-bootstrap";
import { BrowserSupportModal } from "./../BrowserSupportWarning";
import { WorkspaceView } from "./../Workspace/WorkspaceView";
import { ProjectView } from "./../Projects/ProjectView";

export function HomePage() {
    return (
        <div className={"container-fluid"}>
            <BrowserSupportModal />
            <Row lg={12} className=" pl-8">
                <Col lg={3}>
                    <WorkspaceView />
                </Col>
                <Col lg={9} className="center-col">
                    <ProjectView />
                </Col>
            </Row>
        </div>
    );
}
